exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;background-color:#29323b33}.nil-sa-elements-loading-style__textCenter{text-align:center}.nil-sa-elements-loading-style__centerBlock{float:none;margin:0 auto}.nil-sa-elements-loading-style__largeLoading{font-size:1.5em}", ""]);

// exports
exports.locals = {
	"textCenter": "nil-sa-elements-loading-style__textCenter",
	"centerBlock": "nil-sa-elements-loading-style__centerBlock",
	"largeLoading": "nil-sa-elements-loading-style__largeLoading"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/elements/Loading/style.less
// module id = 410
// module chunks = 0